import type { Router } from 'vue-router';
import { site } from './content/site';

/**
 * Matomo-Tracking für die Single-Page-App.
 *
 * Entspricht dem üblichen Matomo-Snippet, aber als Modul statt Inline-Skript
 * (die CSP erlaubt keine Inline-Skripte) und mit einem Seitenaufruf pro
 * Routenwechsel statt nur beim ersten Laden.
 */
type MatomoCommand = [string, ...unknown[]];

declare global {
  interface Window {
    _paq?: MatomoCommand[];
  }
}

export function setupAnalytics(router: Router): void {
  const { url, siteId, disableCookies } = site.matomo;
  if (!url || !siteId) return;

  const base = url.endsWith('/') ? url : `${url}/`;
  const paq = (window._paq = window._paq || []);
  if (disableCookies) paq.push(['disableCookies']);
  paq.push(['enableLinkTracking']);
  paq.push(['setTrackerUrl', `${base}matomo.php`]);
  paq.push(['setSiteId', siteId]);

  const script = document.createElement('script');
  script.async = true;
  script.src = `${base}matomo.js`;
  document.head.appendChild(script);

  let previous: string | null = null;
  router.afterEach((to, _from, failure) => {
    if (failure || !to.meta.page) return;
    // Titel wird in router.afterEach gesetzt; nach dem Rendern erfassen
    setTimeout(() => {
      // Ohne Query-Parameter (z. B. ?deleted=1)
      const current = `${location.origin}${to.path}`;
      if (previous) paq.push(['setReferrerUrl', previous]);
      paq.push(['setCustomUrl', current]);
      paq.push(['setDocumentTitle', document.title]);
      paq.push(['trackPageView']);
      previous = current;
    }, 0);
  });
}
